// extracted by mini-css-extract-plugin
module.exports = {"Paper":"AddPlayer_Paper__3naqv","ButtonSubmit":"AddPlayer_ButtonSubmit__144tN"};